export const IsLiteFeatureEnabled = false;

export const SubscriptionPlanNames = {
  Enterprise: 'ENTERPRISE',
  Free: 'FREE',
  CUSTOM: 'CUSTOM'
};

export const DEFAULT_CURRENCY_CODE = 'INR';
export const DEFAULT_CURRENCY_SYMBOL = '₹';
